import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from "@angular/forms";
import {FooterComponent} from './component/partials/footer/footer.component';
import {NavbarComponent} from './component/partials/navbar/navbar.component';
import {TabBarComponent} from './component/partials/tab-bar/tab-bar.component';
import {AdminLayoutComponent} from './component/admin-layout/admin-layout.component';
import {PublicLayoutComponent} from './component/public-layout/public-layout.component';
import {ToastContainerComponent} from '../shared/toast-container.component';
import {ConfirmDialogComponent} from '../shared/confirm-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    TabBarComponent,
    AdminLayoutComponent,
    PublicLayoutComponent,
    ToastContainerComponent,
    ConfirmDialogComponent,
  ],
  exports: [
    AdminLayoutComponent,
    PublicLayoutComponent,
    FooterComponent,
    NavbarComponent,
  ],
  providers: []
})
export class LayoutModule { }
